module.exports = __webpack_public_path__ + "img/banner-1.b1222234.jpg";